import {
  GET_SELLER_ID_FROM_COOKIE,
  PERSIST_USER_DATA_SUCCESS,
  PERSIST_USER_DATA_PENDING,
  PERSIST_USER_DATA_FAIL,
  LOGOUT_PENDING,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  SET_LOGIN_STATUS,
} from "./mutation-types";

export default {
  [GET_SELLER_ID_FROM_COOKIE](state, payload) {
    state.user.sellerId = payload;
  },
  [PERSIST_USER_DATA_PENDING](state) {
    state.isPersistingUserPending = true;
    state.errorOfPersistUser = null;
  },
  [PERSIST_USER_DATA_SUCCESS](state, payload) {
    state.user = payload;
    state.isPersistingUserPending = false;
    state.errorOfPersistUser = null;
  },
  [PERSIST_USER_DATA_FAIL](state, error) {
    state.isPersistingUserPending = false;
    state.errorOfPersistUser = error;
  },
  [LOGOUT_PENDING](state) {
    state.isPending = true;
    state.errorMessage = null;
  },
  [LOGOUT_SUCCESS](state) {
    state.isPending = false;
    state.errorMessage = null;
    state.user = {
      sellerId: null,
    };
    state.isLoggedIn = false;
    state.isAnonymous = false;
  },
  [LOGOUT_FAIL](state, payload) {
    state.isPending = false;
    state.errorMessage = payload;
  },
  [SET_LOGIN_STATUS](state, { isLoggedIn, isAnonymous }) {
    state.isLoggedIn = isLoggedIn;
    state.isAnonymous = isAnonymous;
  },
};
